import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import { InvestorRelationsTable } from 'modules/common';
import { DialogTitleWithClose } from 'ui';

const IssuerRelationsModal = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false}>
      <DialogTitleWithClose onClose={onClose}>{t('Investor relations')}</DialogTitleWithClose>
      <Box px={4} pb={4}>
        <InvestorRelationsTable />
      </Box>
    </Dialog>
  );
};

IssuerRelationsModal.defaultProps = {
  open: false,
  onClose: () => null,
};

IssuerRelationsModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default IssuerRelationsModal;
